import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import ProgressBar from './ProgressBar';
import * as styles from './ChallengeCardNotStarted.css';

const cx = classNames.bind(styles);

/**
 * Formats a date string as month/year.
 * @param {string} dateStr - ISO date string
 * @returns {string} Formatted date (e.g., "8/2026")
 */
export const formatEndDate = (dateStr) => {
    const date = new Date(dateStr);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${month}/${year}`;
};

const ChallengeCardNotStarted = ({ challenge, onAccept, isAccepting, onExclusionsClick }) => {
    const { offerId, shortDescription, description, progressCompleted, threshold, endDate } = challenge;

    return (
        <div className={cx('challengeCard')}>
            <div className={cx('headingInfo')}>
                <h3 className={cx('title')}>{shortDescription}</h3>
                <p className={cx('description')}>{description}</p>
            </div>
            <div className={cx('progressWrapper')}>
                <ProgressBar progressCompleted={progressCompleted || 0} threshold={threshold} />
            </div>
            <div className={cx('endDateRow')}>
                <p className={cx('endDate')}>Ends {formatEndDate(endDate)}</p>
                <button
                    type="button"
                    className={cx('exclusionsLink')}
                    onClick={() => onExclusionsClick(challenge)}
                >
                    Exclusions &amp; Details
                </button>
            </div>
            <button
                type="button"
                className={cx('ctaButton')}
                onClick={() => onAccept(offerId)}
                disabled={isAccepting}
            >
                Accept the Challenge
            </button>
        </div>
    );
};

ChallengeCardNotStarted.propTypes = {
    challenge: PropTypes.shape({
        offerId: PropTypes.string,
        shortDescription: PropTypes.string,
        description: PropTypes.string,
        progressCompleted: PropTypes.number,
        threshold: PropTypes.number,
        endDate: PropTypes.string,
        offerTermsAndConditions: PropTypes.string,
    }).isRequired,
    onAccept: PropTypes.func.isRequired,
    isAccepting: PropTypes.bool,
    onExclusionsClick: PropTypes.func.isRequired,
};

ChallengeCardNotStarted.defaultProps = {
    isAccepting: false,
};

export default ChallengeCardNotStarted;
